// TODO: get query params string 'procode' in url
export const getQueryParams = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const query_string_procode = params.get('procode');
    const query_string_group = params.get('group');
    return {
        query_string_procode,
        query_string_group
    };
}


// TODO: get user location
export const getLocation = () => {
    let userLocation = {};
    if("geolocation" in navigator){
        navigator.geolocation.getCurrentPosition((location) => {
            userLocation.latitude = location.coords.latitude;
            userLocation.longitude = location.coords.longitude;
        },null);
    }
    return userLocation;
}